<template>
  <div class='tab' v-show='isActive'>
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    label: { required: true },
    active: { default: false},
    icon: { default: false},
    id: { default: false},
    hidden: {default: false},
  },
  data() {
    return {
      isActive: false
    }
  },
  mounted() {
    this.isActive = this.active;
  }
}
</script>
